import { Field } from "ngx-angular-query-builder"
import { FilterFieldProvider } from './filter-field-provider';

export type FieldMetaDataAvailableCallback = (item: FieldMetadata) => boolean;

export class FieldMetadata {
  field: Field;
 
  private readonly availableCallback: FieldMetaDataAvailableCallback;

  constructor(public readonly fieldName: string, field: Field = null, isAvailable: FieldMetaDataAvailableCallback = ()=> true ) {
    this.field = field;
    this.availableCallback = isAvailable;
  }

  isAvailable() {
    if (this.availableCallback == undefined) {
      return true;
    }
    return this.availableCallback(this);
  }

}

export class FieldMetadataCollection  implements FilterFieldProvider {

  private map = new Map<string, FieldMetadata>();

  set(key: string, value: FieldMetadata) {
    return this.map.set(key, value);
  }

  has(key: string) {
    return this.map.has(key);
  }
    
  availableFieldMetadata() {
    return Array.from(this.map).map(kvp => kvp[1]).filter(fmd => fmd.isAvailable());
  }

  getFilterFields(): Field[] {
     return this.availableFieldMetadata().map(fmd => fmd.field);
  }

  getFieldNameFromLabel(label: string): string {
    if (!this.map.has(label)) {
      return '';
    }
    return this.map.get(label).fieldName;
  }

  getFilterField(fieldName: string): Field {
    const found = this.availableFieldMetadata().find(fmd => fmd.fieldName === fieldName);
    return (found == undefined) ? undefined : found.field;
  }

  addFilter(label: string, field: string, type: string, ops: string[], options: any[] = undefined) {
    const filterField = {
      name: label,
      type: type,
      operators: ops,
      options: options
    };
    const fieldMeta = new FieldMetadata(field, filterField);
    this.set(label, fieldMeta);
    return fieldMeta;
  }


}


